import React, {useCallback} from 'react';
import {Tabs} from '@lightricks/react-design-system';
import {TabData} from '@lightricks/react-design-system/dist/components/tabs/TabsProps';
import translate from '@/utils/translate';
import type {TabFilter} from '../../constants';
import {TAB_FILTER} from '../../constants';
import styles from './CampaignStatusTabs.module.scss';

interface CampaignStatusTabsProps {
  activeTab: TabFilter;
  onTabChange: (tab: TabFilter) => void;
  counts: {
    all: number;
    live: number;
    drafts: number;
    completed: number;
  };
  rightSlot?: React.ReactNode;
}

const TABS: {value: TabFilter; localeLabelKey: string}[] = [
  {value: TAB_FILTER.All, localeLabelKey: 'All'},
  {value: TAB_FILTER.Live, localeLabelKey: 'Live'},
  {value: TAB_FILTER.Drafts, localeLabelKey: 'Drafts'},
  {value: TAB_FILTER.Completed, localeLabelKey: 'Completed'},
];

export default function CampaignStatusTabs({
  activeTab,
  onTabChange,
  counts,
  rightSlot,
}: CampaignStatusTabsProps) {
  const tabsData: TabData[] = TABS.map((tab) => ({
    label: `${translate(tab.localeLabelKey)} (${counts[tab.value]})`,
    value: tab.value,
  }));

  const handleChange = useCallback(
    (_event: React.SyntheticEvent, value: string) => {
      onTabChange(value as TabFilter);
    },
    [onTabChange]
  );

  return (
    <div className={styles.container}>
      <Tabs
        testID="campaign-status-tabs"
        size="large"
        appearance="neutral"
        className={styles.tabsContainer}
        onChange={handleChange}
        value={activeTab}
        classes={{root: styles.tabs}}
        tabsData={tabsData}
        big
      />
      {rightSlot}
    </div>
  );
}
